export default "__VITE_ASSET__C6KvchDx__"